import { CfAnchorType } from "./schema";
import { Link } from "gatsby";
import { ReactNode } from "react";
import recursiveRender from "utilities/recursiveRender";

export const convertToPolyLink = ({
  internalLink,
  externalLink,
  params,
  modal,
  anchorType,
  targetBlank,
  dataTracking,
  dataPosition,
}: CfAnchorType) => {
  const target = targetBlank ? "_blank" : "_self";
  const queryParams = params ? `${params}` : "";

  let result: PolyAnchor = {};

  switch (true) {
    case anchorType === "internalLink" && !!internalLink:
      result = {
        as: Link,
        to: `/${internalLink.node_locale}/${internalLink.slug}${queryParams}`,
        target,
        "data-tracking": dataTracking || undefined,
        "data-position": dataPosition || undefined,
      };
      break;
    case anchorType === "externalLink" && !!externalLink:
      result = {
        as: "a",
        href: `${externalLink}${queryParams}`,
        target,
        "data-tracking": dataTracking || undefined,
        "data-position": dataPosition || undefined,
      };
      break;
    case anchorType === "openModal" && !!modal:
      result = {
        as: "div",
        role: "button",
        tabIndex: 0,
        "data-tracking": dataTracking || undefined,
        "data-position": dataPosition || undefined,
        modalRender: recursiveRender({ cfComponent: modal }),
      };
      break;
    default:
      break;
  }

  return result;
};

export const convertJsonAnchorToPolyAnchor = ({
  as = Link,
  href,
  blank,
  dataTracking,
  dataPosition,
}: {
  as?: React.ElementType;
  href: string;
  blank: boolean;
  dataTracking?: string;
  dataPosition?: string;
}): PolyAnchor => ({
  as: href.startsWith("/") ? as : "a",
  ...(href.startsWith("/") ? { to: href } : { href }),
  target: blank ? "_blank" : "_self",
  "data-tracking": dataTracking || undefined,
  "data-position": dataPosition || undefined,
});

export type PolyAnchor = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: React.ElementType<any, keyof React.JSX.IntrinsicElements> | undefined;
  to?: string;
  href?: string;
  target?: string;
  "data-tracking"?: string;
  "data-position"?: string;
  onClick?: VoidFunction;
  onKeyDown?: VoidFunction;
  role?: "button";
  tabIndex?: number;
  modalRender?: ReactNode | ReactNode[];
};
